import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {ContactPageComponent} from './contact-page.component';
import {CommonModule as AppCommonModule} from '@common/common.module';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [
    RouterModule.forChild([{
      path: '',
      component: ContactPageComponent,
    }]),
    CommonModule,
    AppCommonModule,
    TranslateModule.forChild()
  ],
  declarations: [ContactPageComponent],
  exports: [ContactPageComponent],
})
export class ContactPageModule {
}
